import React, { useEffect } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Button,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { kmMessages } from "src/constant/Messages";

const passwordMaxLength = 50;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const Form = ({ onSubmit, answerOption, editMode, ...rest }) => {
  const classes = useStyles();

  const { handleSubmit, register, setValue, control, errors } = useForm();

  return (
    <Card className={clsx(classes.root)} {...rest}>
        <Box component="main">
          <Grid container className={classes.root}>
            <Grid item xs={12} elevation={2}>
              <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl
                  fullWidth
                  className={classes.formcontrol}
                >
                  <Controller
                    as={
                      <TextField
                        autoFocus
                        error={errors.cpassword ? true : false}
                        id="cpassword"
                        name="cpassword"
                        label="Obecne hasło"
                        type="password"
                        placeholder="Obecne hasło"
                        helperText={
                          errors.cpassword &&
                          (formValidation[errors.cpassword.type] || "").replaceAll(
                            "{maxlen}",
                            passwordMaxLength
                          )
                        }
                      />
                    }
                    name="cpassword"
                    defaultValue=""
                    control={control}
                    rules={{ required: true, maxLength: passwordMaxLength }}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  className={classes.formcontrol}
                >
                  <Controller
                    as={
                      <TextField
                        error={errors.password1 ? true : false}
                        id="password1"
                        name="password1"
                        label="Nowe hasło"
                        type="password"
                        placeholder="Nowe hasło"
                        helperText={
                          errors.password1 &&
                          (formValidation[errors.password1.type] || "").replaceAll(
                            "{maxlen}",
                            passwordMaxLength
                          )
                        }
                      />
                    }
                    name="password1"
                    defaultValue=""
                    control={control}
                    rules={{ required: true, maxLength: passwordMaxLength }}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  className={classes.formcontrol}
                >
                  <Controller
                    as={
                      <TextField
                        error={errors.password2 ? true : false}
                        id="password2"
                        name="password2"
                        label="Powtórz nowe hasło"
                        type="password"
                        placeholder="Powtórz nowe hasło"
                        helperText={
                          errors.password2 &&
                          (formValidation[errors.password2.type] || "").replaceAll(
                            "{maxlen}",
                            passwordMaxLength
                          )
                        }
                      />
                    }
                    name="password2"
                    defaultValue=""
                    control={control}
                    rules={{ required: true, maxLength: passwordMaxLength }}
                  />
                </FormControl>
                <Box className={classes.paddingtop}>
                  <Button
                    color="primary"
                    className={classes.button}
                    component={RouterLink}
                    to="/mojekonto"
                  >
                    Anuluj
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.button}
                    endIcon={<SaveIcon />}
                    type="submit"
                  >
                    Zapisz
                  </Button>
                </Box>
              </form>
            </Grid>
          </Grid>
        </Box>
    </Card>
  );
};

export default Form;
